import { render, staticRenderFns } from "./ValProductosNew.vue?vue&type=template&id=33170b3a&"
import script from "./ValProductosNew.vue?vue&type=script&lang=js&"
export * from "./ValProductosNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports